export const definePage = {
    pageNow: 1,
    pageSize: 10
}

// window.definePage = definePage

export const useDefinePage = structuredClone(definePage)


// WEBPACK FOOTER //
// ./src/components/easyPagination/config.js